'use client';

import { logger } from '@lichtblick/logger';
import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { Headline } from '@lichtblick/photon/atoms/headline/headline';
import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';
import { type FC, startTransition, useEffect } from 'react';
import styles from './error.module.css';

interface ErrorPageProps {
  error: Error;
  reset: () => void;
}

const ErrorPage: FC<ErrorPageProps> = ({ error, reset }) => {
  useEffect(() => logger.error(`Uncaught Error in checkout`, {}, error), [error]);

  const retry = () => {
    if (error.name === 'ChunkLoadError') {
      // Next won't be able to recover from a Chunk Load Error – just reload
      startTransition(() => globalThis.location.reload());
    } else {
      reset();
    }
  };

  return (
    <div className={styles.content}>
      <Headline align="center" renderAs="h1">
        Ein unbekannter Fehler ist aufgetreten
      </Headline>
      <span />
      <BoxCTA as="button" onClick={retry}>
        Erneut versuchen
      </BoxCTA>
      <TextCTA as="a" href="/" slim>
        Zurück zur Homepage
      </TextCTA>
    </div>
  );
};

export default ErrorPage;
